import React from "react";
import { Button } from "primereact/button";


const ButtonGroup = (props) => {
    const {buttons} = props

    const handleClick = (command, event) => {
        if (command) {
            command(event)
        }
    }

    return (
        <div className="group-button-container" >
            {buttons.map((button, index) => (
                <Button
                    {...button} 
                    key={index}
                    label={button.label}
                    icon={button.icon}
                    className={`group-button ${button.className ? button.className : ""}`}
                    onClick={(event) => handleClick(button.command, event)}
                />
            ))}
        </div>
    )
}

export default ButtonGroup;
